<template>
<ValidationObserver
        ref="moveDialog"
        v-slot="{ passes }"
    >
    <BaseDialog
        :showDialog="showMoveDialog"
        maxDialogWidth="800"
        maxCardHeight="600"
        :headline="$t('lang_PUBLISHING_INCOME_ACTION_OPTION_MOVE')"
        :close="closeDialog"
        :alvqa="alvqa"
        
    >

        <template v-slot:dialogText>
            <v-container fluid>
                <v-row>
                    <v-col :alvqa="alvqa + '-text'">
                        {{ message }}<br />
                    </v-col>
                </v-row>

                <v-row>
                    <v-col :alvqa="alvqa + '-dropdown'">
                        <BaseEditPageDropdown
                                :label="label" 
                                :items="allCompanies"
                                :context="context"
                                field='SelectedCompany'
                                :withMargin="false"
                                rules='required'
                                :clearable="false"
                                :alvqa="alvqa + '-label-companies'"
                            />
                    </v-col>
                </v-row>
            </v-container>
        </template>

        <template v-slot:dialogActions>
            <v-container fluid>
                <v-row>
                    <v-col class="text-right" align-self="center">
                        <BaseButton 
                            @click="passes(move)"
                            label="lang_GENERAL_CONFIRM"
                            :alvqa="alvqa+'-button-confirm'"
                        />
                    </v-col>
                </v-row>
            </v-container>
        </template>
    
    </BaseDialog>
</ValidationObserver>
  
</template>

<script>

import BaseDialog from '@/components/_base/BaseDialog'
import BaseEditPageDropdown from '@/components/_editForm/BaseEditPageDropdown'
import BaseButton from '@/components/_buttons/BaseButton'

export default {
    name:'MoveIntoCompanyDialog',

    data(){
        return{
            alvqa:"move-contract-dialog",
            label : ''
        }
    },

    props:{
        context:{
            type: String
        },
        message:{
            type: String
        }
    },

    components:{
        BaseDialog,
        BaseEditPageDropdown,
        BaseButton
    },

    computed:{
         showMoveDialog: {
            get() { return this.$store.getters.getShowMoveContractsDialog },
            set(show) { this.$store.commit('setShowMoveContractsDialog', show) }
        },

        allCompanies() {
            let companies = [];
            let parent = this.$route.meta.parentName;
            let child = this.$route.meta.childName;
            let selectedCompanyId = null; // Holds the currently selected company ID
            let companyType = ''; // Holds the type of company (label or publishing)

            // Determine the relevant companies and label text
            if (parent === 'lang_LABEL') {
                companies = JSON.parse(JSON.stringify(this.$store.getters.getLabelCompanies));
                this.label = this.$t('lang_GENERAL_CAPTION_LABEL_COMPANIES');
                selectedCompanyId = this.$store.getters.getSelectedLabelCompanyId;
                companyType = 'label';
            } else if (parent === 'lang_PUBLISHING') {
                companies = JSON.parse(JSON.stringify(this.$store.getters.getPublishingCompanies));
                this.label = this.$t('lang_GENERAL_CAPTION_PUBLISHING_COMPANIES');
                selectedCompanyId = this.$store.getters.getSelectedPublishingCompanyId;
                companyType = 'publishing';
            } else if (parent === 'lang_CONTRACTS') {
                if (child === 'lang_CONTRACTS_PUBLISHING_CONTRACTS') {
                    companies = JSON.parse(JSON.stringify(this.$store.getters.getPublishingCompanies));
                    this.label = this.$t('lang_GENERAL_CAPTION_PUBLISHING_COMPANIES');
                    selectedCompanyId = this.$store.getters.getSelectedPublishingCompanyId;
                    companyType = 'publishing';
                } else {
                    companies = JSON.parse(JSON.stringify(this.$store.getters.getLabelCompanies));
                    this.label = this.$t('lang_GENERAL_CAPTION_LABEL_COMPANIES');
                    selectedCompanyId = this.$store.getters.getSelectedLabelCompanyId;
                    companyType = 'label';
                }
            }

            // Filter out the currently selected company based on its ID
            const filteredCompanies = companies.filter(company => company.id !== selectedCompanyId);
            // Map the filtered companies to the required format
            let newArray = [];
            filteredCompanies.forEach(element => {
                newArray.push({ 'text': element.name, 'value': element.alvId });
            });

            return newArray;
        },
        
    },
    methods:{
        closeDialog(){
            this.showMoveDialog = false
            this.$refs.moveDialog.reset()
            this.$store.commit("set" + this.context + "DetailsSelectedCompany",[])
        },
        move(){
            this.$store.dispatch('moveSelected' + this.context) 
            this.closeDialog()
        }
    }
}
</script>

<style>

</style>